import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  getAllEntities as getLanguages,
  setSelectedLanguage as setSelectedLanguageAction,
  togglePreferencesModalAction,
  toggleProfileOptionsModalAction,
} from '../../redux/actions/appActions';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Select,
  Typography,
  FormControl,
  InputLabel,
  Grid,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SettingsIcon from '@material-ui/icons/Settings';
// Collapsible and autocomplete functionality can be in his own file component(Refactor)
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useStyles } from '../Preferences/styles/styles';
import CloseIcon from '@material-ui/icons/Close';

const PreferencesDialog = ({ isOpen }) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const { userInfo } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  useEffect(() => {
    if (isOpen) {
      dispatch(
        getLanguages(
          userInfo?.data?.payload.brandId,
          userInfo?.data?.payload.hierarchy.rootNodeId,
        ),
      );
    }
  }, [isOpen, userInfo]);
  const handleSave = () => {
    let newLanguage = localStorage.getItem('selectedLanguageTmp') || '';
    localStorage.setItem('selectedLanguage', newLanguage);
    i18n.changeLanguage(newLanguage);
    dispatch(setSelectedLanguageAction(newLanguage));
    dispatch(toggleProfileOptionsModalAction(false));
    dispatch(togglePreferencesModalAction(false));
  };

  const handleCancelEdit = () => {
    let selectedLanguage = localStorage.getItem('selectedLanguage') || '';

    localStorage.setItem('selectedLanguageTmp', selectedLanguage);

    setSelectedLanguageTmp(selectedLanguage);
    dispatch(togglePreferencesModalAction(false));
  };

  const setLanguage = event => {
    if (!event.target.value) {
      return;
    }
    setSelectedLanguageTmp(event.target.value);
    localStorage.setItem('selectedLanguageTmp', event.target.value);
  };

  const languages: [{ name: string; code: string; id: string | number }] =
    useSelector((state: RootStateOrAny) => state.AppReducer.availableLanguages);
  const classes = useStyles();

  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('selectedLanguage') || 'eng',
  );
  const [selectedLanguageTmp, setSelectedLanguageTmp] =
    useState(selectedLanguage);

  useEffect(function () {
    setSelectedLanguage(selectedLanguage);
    localStorage.setItem('selectedLanguageTmp', selectedLanguageTmp);

    return () => {
      localStorage.setItem('selectedLanguageTmp', selectedLanguageTmp);
    };
  });

  return (
    <Dialog
      open={isOpen}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <SettingsIcon />
        {t('app.preferencesModalTitle')}

        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleCancelEdit}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid item>
            <Typography className={classes.heading}>
              {t('app.setupLanguage')}
            </Typography>
          <FormControl variant="outlined" fullWidth size="small">
              <InputLabel
                id="demo-simple-select-outlined-label"
                 className={classes.formControl}
              >
              </InputLabel>
            <Select
              value={selectedLanguageTmp}
              onChange={setLanguage}
              className={classes.formControl}
            >
              {languages?.map(language => (
                <MenuItem key={language.id} value={language.code.toLowerCase()}>
                  {language.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelEdit} color="primary">
          {t('app.common.cancel')}
        </Button>
        <Button type="submit" color="primary" onClick={handleSave}>
          {t('app.common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreferencesDialog;
